var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-alt',{attrs:{"img":_vm.header.img,"title":_vm.header.title}}),_c('faq-view',{attrs:{"title":_vm.header.title,"data":_vm.content},on:{"update":_vm.onUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }